module.exports = __webpack_public_path__ + "img/kan.6307525f.png";